var _g, _g2, _g3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAs2Logo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1021.7 841.9",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "56.5,538.4 160.9,304 213.7,304.1 318.4,538.8 265.4,538.7 187.3,347.8 109.2,538.5 "
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M626.1,304.1l-209.2,0c-4.3,0.1-21.8,0.8-36.6,14.5 c-11.9,11.1-15.2,24.3-16.2,29.2c0,17.2,0.1,34.4,0.1,51.6c0.4,3.9,2.3,18.9,15,30.8c15.4,14.5,34.6,13.2,37.7,12.9 c52.1,0.1,104.1,0.1,156.2,0.2l0,51.7l-209,0l0.1,43.7l208.9-0.1c5.1-0.5,27.7-3.2,42.6-22.3c6.1-7.8,8.9-15.8,10.3-21.4 c0-17.3,0-34.6,0-51.8c-0.7-5.1-3.1-16.6-12.4-27c-15.3-17-36.9-16.9-40.4-16.8c-52.1,0-104.2,0.1-156.3,0.1l0-51.7l209.1,0 L626.1,304.1z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M689,304.2h208.9c4.6,0.2,23.3,1.5,38.2,16.6 c10.1,10.2,13.6,21.8,14.8,27.1c0,17.2,0.1,34.4,0.1,51.6c-0.6,4.8-2.7,17.2-12.6,28c-15.5,16.8-37.2,16.1-40.4,15.9 c-52-0.1-104.1-0.1-156.1-0.2l-0.1,51.8l209.1,0l0,43.4l-209,0.1c-4,0-22-0.2-37-14.1c-12-11.2-15-24.7-15.9-29.3 c0-17.3,0-34.6,0-51.8c0.7-4.8,3.2-17.5,13.9-28.5c15.4-15.7,35.6-15.4,39-15.3c52.1,0,104.2,0,156.2,0l-0.2-51.6l-209,0L689,304.2z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAs2Logo);
export default __webpack_public_path__ + "static/media/as2-logo.5d10e691.svg";
export { ForwardRef as ReactComponent };